import React from 'react';
import { LinkCarousel } from '@noths/polaris-client-ribbons-design-system';

import type { LinkCarouselViewModel } from 'src/components/layouts/hooks/useLinkCarouselViewModel';
import * as styles from '../styles/LinkCarousel.styles';

export type LinkCarouselContainerProps = LinkCarouselViewModel;

/**
 * Related categories and their tracking come from useLinkCarouselViewModel, so
 * this stays props-only.
 */
export const LinkCarouselContainer = (props: LinkCarouselContainerProps) => (
  <div css={styles.linkCarouselWrapper}>
    <LinkCarousel {...props} />
  </div>
);
